import { ErrorStateUIData } from '../../../models/interfaces';

export interface IProduct {
    productId: string;
    productPsId: string;
    number: string;
    name: string;
    offeringId: string;
    data: any;
    dataBonus: any;
    extraSum: number;
    dataSharing: any;
    sms: any;
    voice: any;
    cycleEndInDays: number;
    cycleStarts: string;
    cycleEnds: string;
    cycleEnded: boolean;
    datasharing: boolean;
    sharedData: any[];
    mainMobile: any;
    additionalMobiles: any[];
}

export interface IUserContact {
    value: string;
    verified: boolean;
}

export interface IUser {
    id: string;
    partyId: string;
    fiscalId: string;
    fiscalIdType: string;
    name: string;
    lastname1: string;
    lastname2: string;
    email: IUserContact;
    contactNumber: IUserContact;
    address: string;
}

export interface IControlTimeRequest {
    id: string;
    time: string;
}

export interface IErrorGlobal {
    pathname?: string;
    status?: boolean;
    data?: ErrorStateUIData;
    customRedirection?: boolean;
}

export interface IFeedbackMobile {
    state: string;
    title: string;
    subtitle: string;
    httpCode: string | number;
}

export interface IRootState {
    user?: IUser;
    typeUser?: ETypeUser | undefined;
    isSnackbar?: boolean | undefined;
    isSnackbarProfile?: boolean | undefined;
    isLoggedIn?: boolean | undefined;
    isLoading?: boolean;
    isError?: IErrorGlobal | undefined;
    breadcrumb?: IBreadcrumb[];
    isStopper?: boolean | undefined;
}

export interface IBreadcrumb {
    title: string;
    url: string;
}

export interface IRootStateLine {
    roaming: IControlTimeRequest[];
    blockedNumberSpecials: IControlTimeRequest[];
    dataShared?: IControlTimeRequest[];
}

export enum ETypeUser {
    PRECLIENT = 'PC',
    NORMAL = 'normal',
    LIGHT = 'light',
}

export interface DataShared {
    unit: string;
    current: number;
    max: number;
    extra: number;
}

export interface IConsumption {
    productId: string;
    productPsId: string;
    number: string;
    dataShared: DataShared;
    isMain: boolean;
}

export interface ISlot {
    day: string;
    endInterval: string;
    startInterval: string;
    preferredTechnician: string;
    weekDay: string;
    interval: string;
    mode: string;
}
export interface ISlotSendEndpoint {
    endInterval: string;
    startInterval: string;
    preferredTechnician: string;
    mode: string;
}

export interface IAppConfiguration {
    environment: { [key: string]: string | undefined };
}

export interface RestrictionType {
    restrictionSpecId: string;
    title: string;
    description: string;
    restrictionType: string;
    tramitable: boolean;
    active: boolean;
}
